import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Input from '../../form/Input'
import Select from '../../form/Select'
import Typography from '../../../UniformComponents/Typography'

@observer
export default class CampaignLinksModal extends Component {
    render() {
        const { distributeStore } = this.props
        const { editingCampaign } = distributeStore

        const getTitle = () => {
            switch (distributeStore.campaignType) {
                case 'onsite':
                    return i18n.t(editingCampaign
                        ? 'distributionCampaignLinksModal.editingOnsite'
                        : 'distributionCampaignLinksModal.createOnsite')
                default:
                    return i18n.t(editingCampaign
                        ? 'distributionCampaignLinksModal.editingTitle'
                        : 'distributionCampaignLinksModal.createTitle')
            }
        }

        const getDescription = () => {
            switch (distributeStore.campaignType) {
                case 'onsite':
                    return i18n.t('distributionCampaignLinksModal.onsiteDescription')
                default:
                    return i18n.t('distributionCampaignLinksModal.campaignDescription')
            }
        }

        return (
            <Modal
                show={distributeStore.campaignModalVisible}
                onClose={distributeStore.closeCampaignModal}
            >
                <div className="uc-modal__header">
                    <Typography type="h2">{getTitle()}</Typography>
                </div>

                <br />

                <Typography type="tiny"><span dangerouslySetInnerHTML={{ __html: getDescription() }} /></Typography>

                <br />

                <Input
                    label={i18n.t('distributionCampaignLinksModal.titleInput')}
                    placeholder={i18n.t('form.input.placeholder')}
                    onBlur={distributeStore.updateCampaignTitle}
                    defaultValue={distributeStore.campaignTitle}
                    cssClass={distributeStore.campaignError ? 'campaign-links-modal-input error' : ''}
                />

                <br />

                <Select
                    label={i18n.t('distributionCampaignLinksModal.languageSelect')}
                    options={distributeStore.languages}
                    value={distributeStore.selectedLocale}
                    onBlur={distributeStore.changeLocale}
                    validate={distributeStore.validateLocale}
                    cssClass={distributeStore.localeError ? 'campaign-links-modal-select error' : ''}
                />

                <br />

                {['embed', 'intercept'].includes(distributeStore.campaignType)
                    ? (
                        <Input
                            label={i18n.t('distributionCampaignLinksModal.domainInput')}
                            placeholder={i18n.t('form.input.placeholder')}
                            onBlur={distributeStore.updateDomain}
                            validate={distributeStore.validateDomain}
                            defaultValue={distributeStore.domain}
                            cssClass={distributeStore.domainError ? 'campaign-links-modal-input error' : ''}
                        />
                    )
                    : null}

                {editingCampaign && !['embed', 'intercept', 'qr'].includes(distributeStore.campaignType)
                    ? (
                        <div style={{ position: 'relative' }}>
                            <Typography
                                type="b"
                                cssClass="campaign-links-modal-false-input-header"
                            >
                                {distributeStore.campaignType === 'onsite'
                                    ? i18n.t('distributionCampaignLinksModal.onsiteInput')
                                    : i18n.t('distributionCampaignLinksModal.linkInput')}
                            </Typography>

                            <div
                                className="campaign-links-modal-false-input"
                            >
                                <Typography type="tiny">{distributeStore.campaignLink}</Typography>
                            </div>
                        </div>
                    )
                    : null}

                <ModalFooter cssClass="campaign-links-modal-buttons">
                    <Button
                        cssClass="campaign-links-modal-button tertiary"
                        onClick={distributeStore.closeCampaignModal}
                    >
                        {i18n.t('distributionCampaignLinksModal.actionCancel')}
                    </Button>

                    <Button
                        cssClass="campaign-links-modal-button primary"
                        onClick={distributeStore.saveCampaign}
                    >
                        {i18n.t('distributionCampaignLinksModal.actionSave')}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}
